import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { USER_ROLES } from '../utils'

const useCurrentUser = () => {
	const user = useSelector((state) => state.general.user.user)

	const isBackOfficeUser = useMemo(() => {
		if (!user) {
			return false
		}
		const { roles = [] } = user
		return roles.includes(USER_ROLES.BackOfficeUser) || roles.includes(USER_ROLES.SuperUser)
	}, [user])

	const isPcaSupervisorUser = useMemo(() => {
		if (!user) {
			return false
		}
		const { roles = [] } = user
		return roles.includes(USER_ROLES.PcaSupervisorUser)
	}, [user])

	const isSupportUser = useMemo(() => {
		if (!user) {
			return false
		}
		const { roles = [] } = user
		return roles.includes(USER_ROLES.SupportUser)
	}, [user])

	const isGroomer = useMemo(() => {
		if (!user) {
			return false
		}
		const { roles = [] } = user
		return (
			roles.includes(USER_ROLES.Groomer) &&
			!roles.includes(USER_ROLES.BackOfficeUser) &&
			!roles.includes(USER_ROLES.SuperUser)
		)
	}, [user])

	return {
		user,
		isBackOfficeUser,
		isPcaSupervisorUser,
		isSupportUser,
		isGroomer,
		isSuperUser: Boolean(user?.roles?.includes(USER_ROLES.SuperUser)),
		facilityId: user?.facility_id || null
	}
}

export default useCurrentUser
